<div class="container">
    <div class="half-container">
        <p class="main-title">{{"AUTO_SANITY_CHECK_TITLE" | translate}}</p>
        <p class="main-subtitle">{{"AUTO_SANITY_CHECK_SUBTITLE" | translate}}</p>
    </div>
    <div class="half-container">
    </div>
</div>
<div class="main-container">
    <neoris-sanity-plant></neoris-sanity-plant>
    <neoris-sanity-plant></neoris-sanity-plant>
    <neoris-sanity-plant></neoris-sanity-plant>
</div>